module.exports = __webpack_public_path__ + "static/media/uk_aid.bf3acb2b.png";